export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/30 blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-accent-100/20 blur-3xl"></div>
        <div className="absolute top-1/3 left-1/2 w-[500px] h-[500px] rounded-full bg-primary-50/20 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 pt-20 md:pt-24 pb-12 md:pb-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-label font-semibold mb-5 whitespace-nowrap">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-fire-fill text-xs"></i>
              </span>
              高清视频不缓冲 · 免费在线观看
            </div>

            <h1 className="font-heading font-black text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-4">
              91免费视频网站
              <br />
              <span className="text-primary-500">海量高清视频</span>
              免费在线观看
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              91免费视频网站是一个专注于高清在线视频的免费平台，每日更新海量优质视频资源，覆盖91免费视频网站在线观看、91在线观看视频网站等多元内容。无需付费注册，打开即看，高清流畅不卡顿，致力于为每一位用户提供极致的免费视频网站在线观看体验。
            </p>

            <div className="flex flex-wrap items-center gap-5 justify-center lg:justify-start mb-8">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100">
                  <i className="ri-video-line text-accent-600 text-sm"></i>
                </span>
                <div className="text-left">
                  <p className="text-lg font-bold text-foreground-900">5000+</p>
                  <p className="text-xs text-foreground-500">高清视频资源</p>
                </div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100">
                  <i className="ri-user-heart-line text-primary-600 text-sm"></i>
                </span>
                <div className="text-left">
                  <p className="text-lg font-bold text-foreground-900">每日更新</p>
                  <p className="text-xs text-foreground-500">新鲜内容不断</p>
                </div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100">
                  <i className="ri-shield-check-line text-accent-600 text-sm"></i>
                </span>
                <div className="text-left">
                  <p className="text-lg font-bold text-foreground-900">安全流畅</p>
                  <p className="text-xs text-foreground-500">高清无缓冲</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-fill text-sm"></i>
                </span>
                查看热门排行
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-100 text-foreground-800 font-medium text-sm hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer border border-background-200"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-grid-line text-sm"></i>
                </span>
                浏览内容分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px]">
              <div className="relative rounded-2xl overflow-hidden bg-background-950 shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Vibrant%20entertainment%20streaming%20platform%20hero%20visual%20with%20abstract%20colorful%20gradient%20waves%20in%20warm%20red%20and%20golden%20tones%2C%20modern%20minimalist%20streaming%20interface%20mockup%20overlay%2C%20dark%20background%20with%20glowing%20accents%2C%20cinematic%20widescreen%20composition%2C%20professional%20streaming%20service%20aesthetic&width=520&height=390&seq=hero-video-main-01&orientation=landscape"
                  alt="91免费视频网站高清在线观看平台主视觉"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-play-fill text-[10px]"></i>
                      </span>
                      正在热播
                    </span>
                    <span className="text-background-100 text-xs">高清画质 · 流畅播放</span>
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 md:w-28 md:h-28 rounded-2xl bg-accent-500/20 blur-xl hidden md:block"></div>
              <div className="absolute -top-4 -left-4 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500/15 blur-xl hidden md:block"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}